import { defineStore } from 'pinia';

export const useHeaderStore = defineStore('header', {
	state: () => ({
		logo: {},
		menu: [{}],
		// mobileMenu: [{}],
		pinkLogo: false,
		altLogo: 0,
		hasAnimated: false,
		// Event year of the session detail page currently being viewed (null
		// when not on a session page). Lets the nav highlight the right item
		// since current-year and archive sessions share the /sessions/* URL.
		sessionYear: null,
	}),
	// getters: {
	// },
	actions: {
		init(header) {
			if (!header) return;
			this.menu = header.menu;
			// this.mobileMenu = header.mobileMenu;
			this.logo = header.logo;
		},
	},
});
